//GeneratorFlag:[NoChange]
import Room from './room';

export default {Room}
export{Room}